<template>
  <div>
    <TopoComponent></TopoComponent>
    <div
      class="container vertical-align login escolha mt-4 text-center"
      v-if="resultadoProcessamento == 0"
    >
      <div class="row">
        <div class="col-md-12" v-if="validacao.passivelValidacao">
          <h2>Qual conta você quer ativar?</h2>
          <p class="mb-4 font-weight-normal">
            Seu CPF está cadastrado em mais de uma conta, por isso você deve escolher qual deseja ativar agora.
          </p>
          <p class=""></p>
          <ul class="list-hospital">
            <li
              class="from-left"
              v-for="(clinica, index) in clinicas"
              :key="index"
              @click="
                redirectCadastro(
                  clinica.nomeMae,
                  clinica.cns,
                  clinica.id,
                  clinica.nome,
                  clinica.codigoUnico,
                  clinica.idPaciente,
                  false,
                  clinica.flagPermiteSms,
                  clinica.flagPermiteEmail
                )
              "
            >
              <a href="#">
                <div>{{ clinica.nome }}</div>
                <div class="caption">{{ clinica.nomePaciente}}</div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="divFalha" v-if="resultadoProcessamento == 1">
      <img class="imgFalha" :src="image('medico.svg')" alt="" />
      <p></p>
      <div class="mensagemFalha">
        <h3>CPF não encontrado!</h3>
        <br />
        <p>Não encontramos cadastro para o CPF informado.</p>
      </div>
      <p class="espaco"></p>
      <br />
      <p class="mensagemFalha">
        Se precisar de alguma ajuda. <a href="/suporte">Clique aqui.</a>
      </p>
      <div class="clearfix"></div>
    </div>
    <div class="divFalha" v-if="resultadoProcessamento == 2">
      <img class="imgFalha" :src="image('medico.svg')" alt="" />
      <p></p>
      <div class="mensagemFalha">
        <h3>Todas as suas contas encontram-se ativas!</h3>
        <br />
        <p>
          Caso tenha esquecido sua senha,
          <a href="javascript:void(0)" @click="goToEsqueciSenha">CLIQUE AQUI</a>
          para recuperar sua senha
        </p>
      </div>
      <p class="espaco"></p>
      <br />
      <p class="mensagemFalha">
        Se precisar de alguma ajuda. <a href="/suporte">Clique aqui.</a>
      </p>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import OctadeskComponent from "@/components/OctadeskComponent";
import TopoComponent from "@/components/TopoComponent";
import { getImage } from "../components/utils/fnUtils";
import axios from "axios";

export default {
  components: { TopoComponent, OctadeskComponent },
  name: "home",
  mounted() {
    this.carregarClinicas();
  },
  data() {
    return {
      cpfCadastro: sessionStorage.getItem("cpf"),
      captcha: sessionStorage.getItem("captcha"),
      clinicas: [],
      validacao: {
        passivelValidacao: true,
      },
      isShowBtn: true,
      codigoUnicoClinicaSelecionada: null,
      resultadoProcessamento: -1,
      layout: sessionStorage.getItem("layout"),
    };
  },
  methods: {
    carregarClinicas() {
      axios
        .post(
          process.env.VUE_APP_ROOT_API +
            "/integration/ativacao/paciente/obter-clinicas-ativas",
          {
            cpf: this.cpfCadastro,
          },
          { headers: { captcha: this.captcha } }
        )
        .then((response) => {
          this.clinicas = response.data.object;
          sessionStorage.setItem("clinicas", JSON.stringify(response.data.object))
          if (this.clinicas.length == 1) {
            this.redirectCadastro(
              this.clinicas[0].nomeMae,
              this.clinicas[0].cns,
              this.clinicas[0].id,
              this.clinicas[0].nome,
              this.clinicas[0].codigoUnico,
              this.clinicas[0].idPaciente,
              this.clinicas[0].urlTermo,
              this.clinicas[0].flagPermiteSms,
              this.clinicas[0].flagPermiteEmail
            );
          } else {
            let clinicaDirecionada = sessionStorage.getItem(
              "clinica-direcionada"
            );
            this.clinicas.forEach((clinicaObj) => {
              if (
                clinicaDirecionada != null &&
                clinicaDirecionada == clinicaObj.id
              ) {
                this.redirectCadastro(
                  clinicaObj.nomeMae,
                  clinicaObj.cns,
                  clinicaObj.id,
                  clinicaObj.nome,
                  clinicaObj.codigoUnico,
                  clinicaObj.idPaciente,
                  clinicaObj.urlTermo,
                  clinicaObj.flagPermiteSms,
                  clinicaObj.flagPermiteEmail
                );
                this.clinicas = null;
              }
            });
          }
          this.isShowBtn = true;
          this.resultadoProcessamento = 0;
        })
        .catch(() => {
          this.resultadoProcessamento = 1;
          this.validarQuantidadeDeAcessosAtivos();
        })
        .finally(() => {
          NProgress.done();
        });
    },
    isEmpty(value) {
      if (!value || !value.length) return true;
      return false;
    },
    redirectCadastro(
      nomeMae,
      cns,
      idClinicaEscolhida,
      nomeClinicaEscolhida,
      codigoUnico,
      idPaciente,
      urlTermo = "https://s3.sa-east-1.amazonaws.com/drvirtual/downloads/termo_uso_b2c.pdf",
      flagPermiteSms,
      flagPermiteEmail
    ) {
      sessionStorage.setItem("nomeMae", nomeMae);
      sessionStorage.setItem("cns", cns);
      sessionStorage.setItem("idclinica", idClinicaEscolhida);
      sessionStorage.setItem("nomeClinica", nomeClinicaEscolhida);
      sessionStorage.setItem("urlTermo", urlTermo);
      sessionStorage.setItem("idPaciente", idPaciente);
      sessionStorage.setItem("flagPermiteEmail", flagPermiteEmail);
      sessionStorage.setItem("flagPermiteSms", flagPermiteSms);
      this.codigoUnicoClinicaSelecionada = codigoUnico;
      this.$conexaApi
        .post("/integration/ativacao/paciente/obter-dados", {
          idClinica: idClinicaEscolhida,
          cpf: this.cpfCadastro,
          idPaciente,
        })
        .then((response) => {
          this.validacao = response.data.object;
          sessionStorage.setItem("token", this.validacao.token);
          sessionStorage.setItem(
            "dataNascimento",
            this.validacao.dataNascimento
          );
          sessionStorage.setItem("nomeMae", this.validacao.nomeMae);
          sessionStorage.setItem("flagMaeDesconhecida", this.validacao.flagMaeDesconhecida);
          sessionStorage.setItem("cns", this.validacao.cns);
          sessionStorage.setItem("email", this.validacao.email);
          sessionStorage.setItem("nome", this.validacao.nome);
          sessionStorage.setItem("celular", this.validacao.celular);
          sessionStorage.setItem("idclinica", idClinicaEscolhida);
          this.redirectConfirmarDataDeNascimento();
        })
        .catch((error) => {
          if (
            error.response.data.msg ==
            "Você já está em processo de validação pela nossa equipe."
          ) {
            location.href = "/validacao-pendente";
          }
          this.$notify({
            duration: 4000,
            group: "mensagens",
            type: "error",
            title: "Mensagem",
            text: error.response.data.msg,
          });
        })
        .finally(() => {
          NProgress.done();
        });
    },
    redirectConfirmarDataDeNascimento() {
      this.$router.push("/validar-data-de-nascimento");
    },
    redirecionarLogin() {
      location.href =
        process.env.VUE_APP_ROOT_WEB_PACIENTE +
        "/login/" +
        this.codigoUnicoClinicaSelecionada;
    },
    validarQuantidadeDeAcessosAtivos() {
      this.$conexaApi
        .post("/integration/ativacao/paciente/acessos-ativos", {
          cpf: this.cpfCadastro,
        })
        .then((response) => {
          if (response.data.object > 0) {
            this.resultadoProcessamento = 2;
          } else {
            this.resultadoProcessamento = 1;
          }
        })
        .catch(() => {
          this.resultadoProcessamento = 1;
        })
        .finally(() => {
          NProgress.done();
        });
    },
    image(name) {
      return getImage(name);
    },
    goToEsqueciSenha() {
      if (this.layout === "docpass") {
        location.href = `${process.env.VUE_APP_SITE_DOCPASS}/esqueci-senha`;
      } else
        location.href = `${
          process.env.VUE_APP_ROOT_WEB_PACIENTE
        }/esqueci-senha`;
    },
  },
};
</script>

<style scoped>
.imgFalha {
  max-width: 180px;
  text-align: center;
}
.divFalha {
  text-align: center;
}
.imgContato {
  max-width: 50px;
  text-align: center;
}
.imgWhatsapp {
  max-width: 25px;
  text-align: center;
}
.imgEmail {
  max-width: 25px;
  text-align: center;
}
.mensagemFalha {
  color: gray;
  text-align: center;
  font-size: 20px;
}
.caption {
  color: gray;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  transition: 1s ease-in-out;
}
.from-left:hover .caption {
  color: white;
}
</style>
